import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../partials/aside/Sidebar";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import TitleBar from "../../partials/content/TitleBar";
import publishers from "./publisher";

function ViewCategoryUserSitePublisher() {
  const params = useParams();
  const groupUserSitePublisherID = params.id;
  let groupUserSitePublisherData = publishers.filter(
    (publisher) => publisher.id == groupUserSitePublisherID
  );
  groupUserSitePublisherData = groupUserSitePublisherData[0];

  const generateGroupUserSitePublisherData = () => {
    return (
      <div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space m-0">
            <thead>
              <tr>
                <td>نام گروه</td>
                <td>مبلغ گروه </td>
                <td>تاریخ شروع </td>
                <td>تاریخ پایان </td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{groupUserSitePublisherData.name}</td>
                <td>
                  <span className="letter-spacing-finance-number pr-1">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        groupUserSitePublisherData.amount
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
                <td>
                  {helperNumbers.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      groupUserSitePublisherData.start_date
                    )
                  )}
                </td>
                <td>
                  {helperNumbers.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      groupUserSitePublisherData.end_date
                    )
                  )}
                </td>
                <td>
                  <span className="btn btn-info" onClick={exportReportExcel}>
                    <span className="pl-2">
                      <i className="fa fa-file-excel"></i>
                    </span>
                    <span>خروجی فایل Excel</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>{generateSitePublisherData(groupUserSitePublisherData.sites)}</div>
      </div>
    );
  };

  const calculatePriceSite = (sitePublisherData) => {
    let pricePage = 0;

    for (let pageID in sitePublisherData) {
      if (pageID === "url") {
        continue;
      }
      pricePage += sitePublisherData[pageID].price;
    }
    return pricePage;
  };

  const generateSitePublisherData = (groupUserSitePublisherDataSites) => {
    let tagCollection = [];
    for (const sitePublisherID in groupUserSitePublisherDataSites) {
      const sitePublisherData =
        groupUserSitePublisherDataSites[sitePublisherID];
      tagCollection.push(
        <div className="py-2">
          <div
            className="border border-2 border-warning bg-warning rounded"
            style={{ height: "5px" }}
          ></div>
          <span>سایت : </span>
          <span>
            <a href={sitePublisherData.url} target="_blank">
              {sitePublisherData.url}
            </a>
          </span>
          <span className="pr-1">-</span>
          <span className="pr-1">قیمت سایت : </span>
          <span className="letter-spacing-finance-number">
            {helperNumbers.toPersianNum(
              helperNumbers.toFormatFinanceNumber(
                calculatePriceSite(sitePublisherData)
              )
            )}
          </span>
          <span className="pr-1"> تومان</span>
        </div>
      );
      for (const sitePublisherID in sitePublisherData) {
        if (sitePublisherID === "url") {
          continue;
        }
        const pageData = sitePublisherData[sitePublisherID];
        tagCollection.push(
          <>
            <div className="d-flex">
              <div>عنوان : </div>
              <div>{pageData.title}</div>
              <div className="pr-1">-</div>
              <div className="pr-1">قیمت صفحه :</div>
              <div className="letter-spacing-finance-number">
                {helperNumbers.toPersianNum(
                  helperNumbers.toFormatFinanceNumber(pageData.price)
                )}
              </div>
              <div className="pr-1"> تومان</div>
            </div>
            <div className="container-fluid" id="select-position-container">
              <div className="row">
                {generatePositionBox(pageData.positions)}
              </div>
            </div>
          </>
        );
      }
    }
    return tagCollection;
  };

  const generatePositionBox = (positions) => {
    let tagCardPosition = [];
    for (const key in positions) {
      const position = positions[key];

      tagCardPosition.push(
        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2">
          <div className="bg-success">
            <div className="p-2 d-flex">
              <div className="align-items-center justify-content-center d-flex flex-grow-1">
                <span>اطلاعات جایگاه</span>
                <span className="px-2">-</span>
                <span className="letter-spacing-finance-number">
                  {helperNumbers.toPersianNum(
                    position.tag_html_id.replace("hilite-position-", "")
                  )}
                </span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">اندازه</div>
              <div className="py-2 w-50 text-center">
                <span className="letter-spacing-finance-number" dir="ltr">
                  {helperNumbers.toPersianNum(position.size.replace("-", "×"))}
                </span>
                <span className="pr-2">پیکسل</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">ظرفیت کل</div>
              <div className="py-2 w-50 text-center">
                {helperNumbers.toPersianNum(position.count)}
                <span className="pr-2">بنر</span>
              </div>
            </div>
            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">سهم شما</div>
              <div className="py-2 w-50 text-center">
                {helperNumbers.toPersianNum(1)}
                <span className="pr-2">بنر</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">ارزش کل</div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helperNumbers.toPersianNum(
                    helperNumbers.toFormatFinanceNumber(position.base_price)
                  )}
                </span>
                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">
                پرداختی شما
              </div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helperNumbers.toPersianNum(
                    helperNumbers.toFormatFinanceNumber(position.price)
                  )}
                </span>

                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div className="px-2 d-flex border-top">
              <div className="py-2 w-50 text-center border-left">سهم نمایش</div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helperNumbers.toPersianNum(
                    Math.floor((1 / position.count) * 100)
                  )}
                </span>
                <span className="pr-2">درصد</span>
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              {position.tag_html_id}
            </div>
          </div>
        </div>
      );
    }
    return tagCardPosition;
  };

  const exportReportExcel = () => {
    var option = {};

    option.fileName = groupUserSitePublisherData.name;
    let listSites = groupUserSitePublisherData.sites;
    let dataExcelFile = [
      {
        one: "عنوان گروه",
        two: groupUserSitePublisherData.name,
      },
      {
        one: "مبلغ گروه",
        two: helperNumbers.toPersianNum(
          helperNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(listSites)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helperNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            groupUserSitePublisherData.start_date
          )
        ),
        three: "تاریخ پایان",
        four: helperNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            groupUserSitePublisherData.end_date
          )
        ),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];
    for (let key in listSites) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(listSites[key]),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
      {
        sheetData: dataExcelFile,
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherData
  ) => {
    let sitePublisherUrl = sitePublisherData.url;
    delete sitePublisherData.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helperNumbers.toPersianNum(
          helperNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherData)
          )
        ),
      },
    ];

    for (const key in sitePublisherData) {
      const item = sitePublisherData[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }
    return dataEachSitePublisherExcelFile;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const getPriceSitePublisher = (sitePublisherData) => {
    let pricePage = 0;
    const newSitePublisherData = { ...sitePublisherData };
    delete newSitePublisherData.url;
    for (const key in newSitePublisherData) {
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const generatePageDataReportExportExcel = (sitePublisherData) => {
    return [
      {
        one: sitePublisherData.title,
        two: helperNumbers.toPersianNum(
          helperNumbers.toFormatFinanceNumber(sitePublisherData.price)
        ),
      },
      { ...generateTagHtmlID(sitePublisherData.positions) },
      { one: "", two: "" },
    ];
  };

  const generateTagHtmlID = (positions) => {
    return positions.map((item) => item.tag_html_id);
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-category-user-site-publishers"
      />

      <div className="content-wrapper">
        <TitleBar title="نمایش دسته های سایت های نمایش دهنده کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>{generateGroupUserSitePublisherData()}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ViewCategoryUserSitePublisher;
